export default __webpack_public_path__ + "static/media/detail_big_13_2.60097112.jpg";